import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import Works from '@/pages/Works.vue'
import Posts from '@/pages/Posts.vue'
import Contact from '@/pages/Contact.vue'
import Service from '@/pages/Service.vue'
import Workinfo from '@/pages/Casestudy.vue'
import Postread from '@/pages/Postread.vue'
import Lost from '@/pages/Error.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    }, {
      path: '*',
      redirect: '/error'
    }, {
      path: '/home',
      name: 'Home',
      meta: {
        title: 'UI设计_网站开发'
      },
      component: Home
    }, {
      path: '/works',
      name: 'Works',
      meta: {
        title: 'Works作品'
      },
      component: Works
    }, {
      path: '/posts',
      name: 'Posts',
      meta: {
        title: 'Insights观点'
      },
      component: Posts
    }, {
      path: '/contact',
      name: 'Contact',
      meta: {
        title: 'Contact联系'
      },
      component: Contact
    }, {
      path: '/service',
      name: 'Service',
      meta: {
        title: 'Service服务'
      },
      component: Service
    }, {
      path: '/error',
      name: 'Lost',
      component: Lost
    }, {
      path: '/works/:id',
      name: 'Workinfo',
      component: Workinfo
    }, {
      path: '/posts/:id',
      name: 'Postread',
      component: Postread
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/router.js